import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {ReviewerReviewService} from '../reviewer-review.service';


@Injectable()
export class AllReviewsResolver implements Resolve<any> {
	constructor(
		private reviewerReviewService: ReviewerReviewService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		console.log('AllReviewsResolver called    #1');

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			this.reviewerReviewService.getAllReviews()
				.then((reviews: any) => {

					console.log('AllReviewsResolver called    #2');

					let allReviewsInfo = {
						allReviews: reviews,
						params: this.params
					};
					resolve(allReviewsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-reviews.resolver.ts